import { render, staticRenderFns } from "./itemModifier.vue?vue&type=template&id=67fe8b1c"
import script from "./itemModifier.vue?vue&type=script&lang=ts"
export * from "./itemModifier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports